import Cookies from 'js-cookie';

function AdminController($route, $scope, $location, AdminDrawsSvc, AdminDrawSvc, AdminDrawMarkedPaidSvc, AdminDrawTicketNumberSvc, RNDNumberSvc) {
  'ngInject';

  $scope.Processing = false;
  $scope.TodaysDate = new Date();

  //$scope.AdminDraws = {};
  jQuery(document).ready(function ($) {
      if (Cookies.get('TLF_Auth_Token') !== undefined) {
          AdminDrawsSvc.get({ APIKey: Cookies.get('TLF_Auth_Token') }, function (data) {
              $scope.AdminDraws = data;
          });
      } else
      {
          var date = new Date();
          var minutes = 60000;
          date.setTime(date.getTime() + (minutes * 60 * 1000));
          Cookies.set('TLF_LastPage', $location.$$path, { expires: date });
          $location.path('/connect').replace();
          $route.reload();
      }
  });

  $scope.DownloadCSV = function (DrawId) {
      jQuery(document).ready(function ($) {
          if (Cookies.get('TLF_Auth_Token') !== undefined) {
              return TFL_Base_Url + 'admin/draw/downloadcsv?ApiKey=' + Cookies.get('TLF_Auth_Token') + '&DrawId=' + DrawId;
          }
      });
  }

  $scope.CheckWinningNumber_blur = function ($index) {
      $scope.Processing = true;
      jQuery(document).ready(function ($) {
          if (Cookies.get('TLF_Auth_Token') !== undefined) {
              AdminDrawTicketNumberSvc.post({ APIKey: Cookies.get('TLF_Auth_Token'), DrawId: $scope.AdminDraws[$index].DrawId, TicketNumber: $scope.AdminDraws[$index].WinningNumber }, function (data) {
                  if (data.hasDrawn == true) {
                      $scope.AdminDraws[$index] = data;
                      $scope.AdminDraws[$index].ValidWinner = true;
                      //Update next draw
                      $scope.AdminDraws[$index + 1].canDraw = true;
                  }
                  else {
                      $scope.AdminDraws[$index].ValidWinner = false;
                  }
                  $scope.Processing = false;
              });
          }
      });
  }

  $scope.CheckWinningNumber_Keyup = function ($index) {
      if ($scope.AdminDraws[$index].WinningNumber.length >= 7) {
          $scope.Processing = true;
          jQuery(document).ready(function ($) {
              if (Cookies.get('TLF_Auth_Token') !== undefined) {
                  AdminDrawTicketNumberSvc.post({ APIKey: Cookies.get('TLF_Auth_Token'), DrawId: $scope.AdminDraws[$index].DrawId, TicketNumber: $scope.AdminDraws[$index].WinningNumber }, function (data) {
                      if (data.hasDrawn == true)
                      {
                          $scope.AdminDraws[$index] = data;
                          $scope.AdminDraws[$index].ValidWinner = true;
                          //Update next draw
                          $scope.AdminDraws[$index + 1].canDraw = true;
                      }
                      else
                      {
                          $scope.AdminDraws[$index].ValidWinner = false;
                      }
                      $scope.Processing = false;
                  });
              }
          });
      }
  }

  $scope.UpdateReference = function ($index)
  {
      if ($scope.AdminDraws[$index].ReferenceNumber != '' && $scope.AdminDraws[$index].ReferenceNumber != null) {
          jQuery(document).ready(function ($) {
              if (Cookies.get('TLF_Auth_Token') !== undefined) {
                  AdminDrawMarkedPaidSvc.post({ APIKey: Cookies.get('TLF_Auth_Token'), DrawId: $scope.AdminDraws[$index].DrawId, TicketNumber: $scope.AdminDraws[$index].WinningNumber, RefrenceNumber: $scope.AdminDraws[$index].ReferenceNumber }, function (data) {
                      //Update UI
                      $scope.AdminDraws[$index].hasPaid = true;
                  });
              }
          });
      }
  }

  $scope.CurrentDraw = {};
  $scope.CurrentDrawIndex = {};
  $scope.CurrentDrawCSV = {};
  $scope.AdminModal_Primary = {};
  $scope.AdminModal_Secondary = {};

  $scope.PromptDraw = function ($index, type) {
      $scope.CurrentDraw = $scope.AdminDraws[$index];
      $scope.CurrentDrawIndex = $index;

      //Flag for first launch or not. 1 - First, 2 - Second
      if (type === 1)
      {
          $scope.AdminModal_Primary = {display: 'block'};
          $scope.AdminModal_Secondary = { display: 'none' };
      }
      else
      {
          $scope.AdminModal_Primary = { display: 'none' };
          $scope.AdminModal_Secondary = { display: 'block' };
      }


      jQuery(document).ready(function ($) {
          //Reset Progress
          $('#admin-modal .download-options .option').parents('.col').removeClass('move');

          //Setup Download Link
          $scope.CurrentDrawCSV = TFL_Base_Url + 'admin/draw/downloadcsv?ApiKey=' + Cookies.get('TLF_Auth_Token') + '&DrawId=' + $scope.CurrentDraw.DrawId;
          $scope.CurrentDraw_ExtendedCSV = TFL_Base_Url + 'admin/draw/downloadextendedcsv?ApiKey=' + Cookies.get('TLF_Auth_Token') + '&DrawId=' + $scope.CurrentDraw.DrawId;

          //Show Admin Modal
          $('#admin-modal').fadeIn(500);
      });

  }


  $scope.GetRNGNumber = function (DrawId) {
    jQuery(document).ready(function ($) {
      if (Cookies.get('TLF_Auth_Token') !== undefined) {
        RNDNumberSvc.get({ APIKey: Cookies.get('TLF_Auth_Token'), DrawId: DrawId }, function (data) {
          $scope.CurrentDraw.WinningNumber = data.Number;
          $scope.CheckWinningNumber_Keyup($scope.CurrentDrawIndex);
        });
      }
      $('#admin-modal').fadeOut(500);
    });
  }


  $scope.MomentDate = function(mili)
  {
      return moment.unix(mili).toNow(true);
  }

  $scope.SetDownloaded = function ()
  {

      jQuery(document).ready(function ($) {
          if (Cookies.get('TLF_Auth_Token') !== undefined) {
              AdminDrawSvc.get({ APIKey: Cookies.get('TLF_Auth_Token'), DrawId: $scope.CurrentDraw.DrawId }, function (data) {
                  //Update UI
                  $scope.AdminDraws[$scope.CurrentDrawIndex].hasDownloaded = true;

                  $('#admin-modal').hide();
                  $scope.PromptDraw($scope.CurrentDrawIndex, 2);
              });
          }
      });
  }
};

export default {
  name: 'AdminCTRL',
  fn: AdminController
};
